import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 1,
  sequence: 0,
  'filter[categoryids][0]': 4
};
import { threadList, banner } from '@/api/mg';
export default {
  data: function data() {
    return {
      totalPage: 0,
      loading: false,
      finished: false,
      isLoading: false,
      newsData: [],
      banner: [
        // { src: require('../../../assets/images/Banner1.png') },
        // { src: require('../../../assets/images/Banner2.png') }
      ],
      infos: [{
        isFollow: true
      }, {
        isFollow: false
      }, {
        isFollow: true
      }, {
        isFollow: false
      }]
    };
  },
  created: function created() {
    threadListParams.page = 1;
    this.getThreadList(threadListParams);
    this.getBanner({
      page: 1,
      perPage: 6
    });
  },
  methods: {
    getBanner: function getBanner(params) {
      var _this = this;
      banner(params).then(function (res) {
        if (res.Code === 0) {
          _this.banner = res.Data.pageData;
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    onLoad: function onLoad() {
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
    },
    getThreadList: function getThreadList(params) {
      var _this2 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.pageData.length === 0) {
            _this2.$toast('No Data');
          }
          _this2.totalPage = res.Data.totalPage;
          _this2.newsData = [].concat(_toConsumableArray(res.Data.pageData), _toConsumableArray(_this2.newsData));
          _this2.loading = false;
          _this2.isLoading = false;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    onRefresh: function onRefresh() {
      this.finished = false;
      this.newsData = [];
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
    },
    toDetail: function toDetail(threadId) {
      console.log(threadId);
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'news',
          threadId: threadId
        }
      });
    }
  }
};